<template>
  <div class="main">
    <div class="contain" v-if="sitename != ''">
      <a-card hoverable title="更新首页" class="siteinfo" :bordered="false">
        <div class="operate">
          <a-row type="flex" justify="space-around" align="middle">
            <a-col :span="12" style="text-align:center;">
              <a-button type="primary" class="button" @click="preview">预览</a-button>
            </a-col>
            <a-col :span="12" style="text-align:center;">
              <a-button class="button" @click="publish">发布</a-button>
            </a-col>
          </a-row>
          <div></div>
        </div>
      </a-card>
    </div>
    <div class="spin" v-else>
      <a-spin tip="Loading..." />
    </div>
  </div>
</template>

<script>
import { Icon } from 'ant-design-vue';
const IconFont = Icon.createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1391373_suybzs2x9f.js'
});

export default {
  name: 'EditUser',
  data() {
    return {
      sitename: ''
    };
  },
  created() {
    this.siteinfo();
  },
  methods: {
    async siteinfo() {
      let res = await this.$http.post('/api/Snapshot/getCacheStatus');
      if (res.data.state == 200) {
        this.indexCache = res.data.data.cache == 0 ? false : true;
        this.sitename = res.data.data.sitename;
      } else {
        this.$error({
          title: '错误',
          content: '获取配置错误，请联系管理员。'
        });
      }
    },
    async preview() {
      let res = await this.$http.post('/api/Snapshot/preview');
      if (res.data.state == 200) {
        this.$confirm({
          title: '操作成功',
          // JSX support
          content: (
            <div>
              <p>预览链接已生成，有效期5分钟，请尽快查看。</p>
              <p>{res.data.data}</p>
            </div>
          ),
          okText: '知道了',
          cancelText: '打开链接',
          closable: true,
          onCancel() {
            window.open(res.data.data);
          }
        });
      } else {
        this.$error({
          title: '错误',
          content: '预览链接生成失败，可能是站点配置错误，请联系管理员。'
        });
      }
    },
    publish() {
      let that = this
      this.$confirm({
        title: '操作确认',
        // JSX support
        content: (
          <div>
            <p>点击确认按钮将更新网站首页</p>
          </div>
        ),
        closable: true,
        onOk() {
          that.$http.post('/api/Snapshot/publish').then(res=>{
            if (res.data.state == 200) {
              that.$message.success('操作成功');
            }else{
              that.$message.error('操作失败');
            }
          })
        }
      });
    }
  }
};
</script>

<style scoped>
.main {
  position: absolute;
  top: 40px;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
}
.contain {
  margin-top: 2px;
  position: absolute;
  /*padding: 10px 0 0 10px;*/
  top: 0;
  left: 0;
  right: 0;
  bottom: 5px;
  overflow: hidden;
}
.contain .siteinfo {
  margin: 20px auto;
  width: 800px;
}
.contain .siteinfo >>> .ant-card-head-title {
  padding-left: 20px;
}
.contain .siteinfo >>> .ant-card-body {
  padding: 20px;
  min-height: 200px;
}
.intro {
  padding-left: 20px;
  margin-bottom: 20px;
  color: hsl(0, 0%, 60%);
  text-align: left;
}
.operate {
  height: 50px;
  padding-top: 20px;
  position: relative;
}
.operate .button {
  width: 40%;
  height: 100px;
  font-size: 28px;
  margin: 0 auto;
}
.spin {
  width: 100%;
  height: 400px;
  line-height: 400px;
  text-align: center;
}
code {
  margin: 0 1px;
  background: #f2f4f5;
  padding: 0.2em 0.4em;
  border-radius: 3px;
  font-size: 0.9em;
  color: #7e7e7e;
  border: 1px solid #eee;
}
</style>